// export * from "./sorters"
// export * from "./filters"
// export * from "./mappers"
// export * from "./reducers"

import * as map from "./mappers";
import * as sort from "./sorters";
import * as filter from "./filters";
import * as reduce from "./reducers";

export type ComposedValue = {
    name: string,
    method: string,
    cb: (...params) => any[]
}

function composer(method, data, name): ComposedValue {
    return { name, method, cb: data[name] }
}

export const allComposables = ([
    ...Object.keys(map).map(composer.bind(void 0, "map", map)),
    ...Object.keys(sort).map(composer.bind(void 0, "sort", sort)),
    ...Object.keys(reduce).map(composer.bind(void 0, "reduce", reduce)),
    ...Object.keys(filter).map(composer.bind(void 0, "filter", filter))
] as any).reduce((a: any, b: ComposedValue) => {
    a[b.name] = b;
    return a;
}, {});